export default "__VITE_ASSET__D_tNULKH__"